import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_BackgroundRemover = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/background-remover',
			name: 'AI Background Remover | Remove BG Online | Lift',
			description:
				'Erase backgrounds to transparent PNG in seconds. Online AI background remover, no watermarks, batch up to 20 images. Try Lift BG Remover now.',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/background-remover#product' },
				{ '@id': 'https://liftapp.ai/background-remover#howto' },
				{ '@id': 'https://liftapp.ai/background-remover#benefits' },
				{ '@id': 'https://liftapp.ai/background-remover#faq' },
				{ '@id': 'https://liftapp.ai/background-remover#why-lift' },
				{ '@id': 'https://liftapp.ai/background-remover#explore-tools' },
				{ '@id': 'https://liftapp.ai/background-remover#all-in-one' },
			],
		},

		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/background-remover#product',
			name: 'AI Background Remover',
			description:
				'Erase backgrounds to transparent PNG in seconds. Online AI background remover, no watermarks, batch up to 20 images. Try Lift BG Remover now.',
			url: 'https://liftapp.ai/background-remover',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
				image: 'https://liftapp.ai/seo-image.webp',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/background-remover#howto',
			name: 'How to remove background from photo using Lift AI',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your image',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Let the AI do the work',
					text: 'Watch as Lift removes the background automatically',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefits
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/background-remover#benefits',
			name: 'Who Can Benefit from Background Remover?',
			description:
				'Lift’s AI Background Remover helps sellers, creators, designers, and more produce clean, professional visuals effortlessly.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Present your products on clean, distraction-free backgrounds to build trust and drive more sales. Ideal for selling on Amazon, Etsy, or your own online store',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Make your content stand out on social media. A clean background helps your YouTube thumbnails, Instagram posts, and stories grab more attention and boost engagement\n',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Show properties at their best with sharp, focused visuals that leave a strong first impression on buyers and renters',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Easily design eye-catching materials like event posters, class presentations, or flyers that feel polished and professional',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Boost your personal brand with scroll-stopping images that look professional, creative, and on-brand — perfect for influencers and creators',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'The Object Remover feature seamlessly combines quick solutions with professional-grade outcomes, making it a must-have for both personal and business applications',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefit.030c53f9.webp',
				name: 'Clean product images with AI background remover',
				description:
					'Example image showing background removed from product photos using Lift',
			},
		},
		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/background-remover#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Background Remover?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Background Remover is a premium online tool that instantly removes image backgrounds with pixel-perfect precision — ideal for product photos, profile pictures, or graphic design.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Background Remover work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI automatically detects people, objects, and edges using deep segmentation models. It cleanly removes the background while preserving fine details like hair or shadows. Everything runs in the cloud — no manual editing needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will it keep hair, edges, and fine details?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift AI Background Remover uses advanced edge detection to preserve delicate elements like hair, fur, shadows, and soft textures — so you get clean, natural-looking cutouts without manual touch-ups.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},
		// why-lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/background-remover#why-lift',
			name: 'Why Lift’s AI Background Remover stands out',
			description:
				'Discover how Lift’s AI-powered Background Remover delivers professional results with smart, affordable, and cross-platform support.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],

			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/removeTool.add08f94.webp',
				name: 'Auto-remove background from product photos',
				description: 'Product backgrounds removed with Lift AI tool',
			},
		},
		// explore-tools
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/background-remover#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		// all-in-one
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/background-remover#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Background Remover',
					item: 'https://liftapp.ai/background-remover',
				},
			],
		},
	],
};
